import { forwardRef } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import type { LinkComponentProps } from '@cloudflare/kumo'

// Bridges Kumo's presentational `href` to react-router's `to`.
// Kumo may pass BOTH href and the legacy `to`; strip both, prefer href.
export const AppLink = forwardRef<HTMLAnchorElement, LinkComponentProps>(function AppLink(
  { href, to, ...rest },
  ref,
) {
  return <RouterLink ref={ref} to={href ?? to ?? ''} {...rest} />
})
